
import React from 'react';
import "./VideoEditor.css";
import firebase from '../Firebase';

class VideoEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playTime: 0,
      playPercent: 0,
      seeking: false
    };
  }

  componentDidMount() {
    var video = document.getElementById("videoPlayer");
    var component = this;

    video.addEventListener('timeupdate', function () {
      var percentage = Math.floor((100 / video.duration) * video.currentTime);
      component.setState({ playTime: video.currentTime, playPercent: percentage });
      console.log('video time: ' + video.currentTime);
    })

    this.video = video;

    this.loadVideo();
  }

  loadVideo = () => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user != null) {
        const db = firebase.firestore();
        const uid = firebase.auth().currentUser.uid;

        const { vid } = this.props.match.params;
        this.videoDocRef = db.collection("users").doc(uid).collection("videos").doc(vid);
        this.videoDocRef.get().then((result) => {
          var videoData = result.data();
          this.setState({ videoName: videoData.videoName, videoUrl: videoData.videoUrl, videoThumb: videoData.videoThumb });
        });
      }
    });
  }

  seek = (e) => {
    var video = this.video;
    var percent = e.target.value / 100;
    video.currentTime = percent * video.duration;
    this.setState({ seeking: false });
  }

  handleSeekStart = () => {
    this.setState({ seeking: true });
  }

  handlePlayClick = () => {
    this.video.play();
  }

  handlePauseClick = () => {
    this.video.pause();
  }

  render() {
    const { vid } = this.props.match.params;

    var progressValues = {
      onMouseDown: this.handleSeekStart,
      onMouseUp: this.seek
    };

    if (!this.state.seeking) {
      progressValues.defaultValue = this.state.playPercent;
    }

    return (
      <div>
        <h1>Editing - {this.state.videoName} </h1>
        <div className="editorWrapper">

          <div className="videoPlayer">
            <video id="videoPlayer" src={this.state.videoUrl} />
            <p>
              {/* {this.state.playTime} */}
              <button onClick={this.handlePlayClick}>Play</button>
              <button onClick={this.handlePauseClick}>Pause</button>
            </p>
            <input id="progressBar" type="range" min="0" max="100" className="slider" {...progressValues} />
          </div>

          <div className="subtitlePoints">
            <ul>
              <li>This is a subtitle</li>
              <li>This is another subtitle</li>
            </ul>
          </div>

          <div className="subtitleEditor">
            Enter Text Here
          </div>
        </div>
      </div>
    )
  }
}

export default VideoEditor;